import React from 'react'
import { Drawer } from 'antd'
import {
  PENDENCIES_STATUS,
  PENDENCY_STATUS_COLORS,
  REPORT_MAP,
  generateDeadlineByExpiration,
  pendingsDateLabel,
} from 'screens/Pendings/utils'
import EmptyState from 'components/EmptyState'
import { Link, withRouter } from 'react-router-dom'
import css from './index.scss'
import { getDeadlineColor } from '../PendingCard'

const LABELS_BY_STATUS = {
  RESOLVED: 'Observação da Resolução',
  DISPOSED: 'Observação do Descarte',
}
const RESOLVED_TEXTS = {
  RESOLVED: 'Resolvido por',
  DISPOSED: 'Descartado por',
}

const PendencieActionDrawer = ({
  visible,
  onClose,
  onResolvePendency,
  onRemovePendency,
  pending,
  history,
}) => {
  const path =
    pending?.shippingType === 'SINGLE'
      ? `/loads/${pending?.shippingHash}/details`
      : `/loads/${pending?.shippingHash}/details/delivery/${pending?.shippingDeliveryId}`

  return (
    <Drawer
      visible={visible}
      onClose={onClose}
      width="600px"
      bodyStyle={{ width: '100%', height: '100%' }}
    >
      {typeof pending === 'string' ? (
        <EmptyState captionText={pending} />
      ) : (
        <div className={css.wrapper}>
          <h2 className={css.drawerTitle}>{pending?.pendingType?.name}</h2>
          <span
            className={css.description}
            style={{
              marginBottom: 35,
              color: pending?.status
                ? PENDENCY_STATUS_COLORS[pending?.status]
                : '#828282',
              fontSize: 16,
              fontWeight: 400,
            }}
          >
            {PENDENCIES_STATUS.find((p) => p.value === pending?.status)?.label}
          </span>
          <span className={css.title} style={{ color: '#eb5757' }} />
          <div className={css.contentBox}>
            <span className={css.title}>Código da carga</span>
            <Link
              to={path}
              onClick={(e) => {
                e.preventDefault()
                onClose()
                history.push(path)
              }}
              className={css.link}
            >
              {pending?.externalId}
            </Link>
          </div>
          <div className={css.contentBox}>
            <span className={css.title}>Tipo de solicitante</span>
            <span className={css.description}>
              {pending?.pendingType?.reporterType
                ? REPORT_MAP[pending.pendingType?.reporterType] ||
                  pending.pendingType?.reporterType
                : ''}
            </span>
          </div>
          <div className={css.contentBox}>
            <span className={css.title}>Reportado por</span>
            <span className={css.description}>
              {pending?.createdBy
                ? REPORT_MAP[pending?.createdBy?.toUpperCase()] ||
                  pending?.createdBy
                : 'n/a'}
            </span>
          </div>
          <div className={css.contentBox}>
            <span className={css.title}>Data da abertura</span>
            <span className={css.description}>{pending?.createdDate}</span>
          </div>
          <div className={css.contentBox}>
            <span className={css.title}>
              {pendingsDateLabel[pending?.status]}
            </span>
            {pending?.status === 'OPEN' ? (
              <span
                className={[
                  css.description,
                  getDeadlineColor(pending?.amountDaysToResolve),
                ].join(' ')}
              >
                {generateDeadlineByExpiration(pending?.amountDaysToResolve)}
              </span>
            ) : (
              <span className={[css.description].join(' ')}>
                {pending?.status === 'RESOLVED'
                  ? pending?.resolvedDate
                  : pending?.disposedDate}
              </span>
            )}
          </div>
          <div
            className={css.contentBox}
            style={{ borderBottom: pending?.status === 'OPEN' ? 'none' : '' }}
          >
            <span className={css.title}>Observação da Pendência</span>
            <span className={css.description}>{pending?.openObservation}</span>
          </div>
          {RESOLVED_TEXTS[pending?.status] && (
            <div className={css.contentBox}>
              <span className={css.title}>
                {RESOLVED_TEXTS[pending?.status]}
              </span>
              <span className={css.description}>
                {pending?.status === 'RESOLVED'
                  ? pending.resolvedBy
                  : pending.disposedBy}
              </span>
            </div>
          )}
          {LABELS_BY_STATUS[pending?.status] && (
            <div className={css.contentBox} style={{ borderBottom: 'none' }}>
              <span className={css.title}>
                {LABELS_BY_STATUS[pending?.status]}
              </span>
              <span className={css.description}>
                {pending?.status === 'RESOLVED'
                  ? pending.resolveObservation
                  : pending.disposeObservation}
              </span>
            </div>
          )}
          <div className={css.footer}>
            <button className={css.cancelButton} onClick={onClose}>
              Fechar
            </button>
            {pending?.status === 'OPEN' &&
              pending?.pendingType?.targetType === 'TRANSPORTER' && (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
                  {pending?.pendingType?.canBeDisposed && (
                    <button
                      className={css.disposeBtn}
                      onClick={() => onRemovePendency(pending)}
                    >
                      {pending?.pendingType?.disposeButton || 'Descartar'}
                    </button>
                  )}
                  {pending?.pendingType?.type !==
                    'REQUEST_FIX_DELIVERY_RECEIPT' && (
                    <button
                      className={css.button}
                      onClick={() => onResolvePendency(pending)}
                    >
                      {pending?.pendingType?.resolveButton || 'Resolver'}
                    </button>
                  )}
                </div>
              )}
          </div>
        </div>
      )}
    </Drawer>
  )
}

export default withRouter(PendencieActionDrawer)
